module.exports = __webpack_public_path__ + "img/logo_grupo.3e0d91e1.png";